exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".meta-submit {\n  position: fixed;\n  bottom: 2em;\n}\n.form-item .react-tel-input {\n  line-height: 0;\n}\n.form-item .react-tel-input .form-control {\n  width: 15rem !important;\n}\n", ""]);

// exports
